<template>
  <div>
    <v-layout  class="secondaryTopbar justify-space-between bg-g1 flex-wrap" >
      <!-- breadcrumb -->
      <v-layout data-qa="breadcrumb" class="align-center px-4 py-2">
        <v-icon style="margin-right:16px">{{ icon }}</v-icon>
        <div
          v-bind:data-qa="'breadcrumb-path-' + p"
          v-for="(p, index) in path"
          :key="p"
          d-inline
          class="mr-3"
        >
          <span v-if="index > 0" class="mr-3">></span>
          <span>{{ p }}</span>
        </div>
      </v-layout>
      <slot></slot>
        <!-- sort dropdown -->
        <div class="breadcrumb-element d-flex " v-if="sortingValues.length > 0">
          <v-divider vertical :thickness="1"></v-divider>
          <div class="sort-dropdown xs-flex-grow " data-qa="sort-dropdown" >
            <v-select
              class="corvina-select no-underline"
              :class="[{backgroundHighlight: needHighlightSortBy}]"
              ref="sortDropdown"
              style="font-size: 12px!important"
              item-title="text"
              item-value="value"
              v-model="sortValue"
              @update:modelValue="sortSelect"
              menu-icon="ecc:ecc-M-Freccia"
              :items="sortingValues"
              :label="$t('breadcrumb.sortBy')"
              :single-line="true"
              density="compact"
              variant="filled"
            />
          </div>
          <v-divider vertical :thickness="1"></v-divider>
          <v-layout :class="[{backgroundHighlight: needHighlightSortBy}]" class="mx-2">
            <v-btn
              data-qa="sort-btn" 
              class="sort-dropdown-button"
              :disabled="sortValue == $t('breadcrumb.sortBy').toString()" 
              icon="ecc:ecc-TB-Sort" 
              @click="reverseSort()"
              :class="[{backgroundHighlight: needHighlightSortBy},{ rotate180: !sortAsc }]"
              variant="outlined"/>
          </v-layout>
        </div>
        <v-layout class="breadcrumb-element" :class="{backgroundHighlight:isSearching==true && !isTagSelected==true, 'bg-white': !(isSearching==true && !isTagSelected==true)}">
          <v-divider :thickness="2" vertical></v-divider>
          <!-- SEARCHBAR FOR FREE TEXT SEARCH ALARMS -->
          <Searchbar v-if="!isTagSelected"
            background="bg-white"
            :searchTitle="searchTitle"
            :searchModel="searchModel"
            :confirmEnabled="true"
            :clearOnConfirm="false"
            :iconEnabled="false"
            @setValue="searchEnter"
          />
          <!-- SELECT FOR ALARMS TYPE AND NAME -->
          <div v-if="tagEnabled && isTagSelected" class="sort-dropdown bg-g1" style="width:13em">
            <v-select
                class="corvina-select no-underline"
                ref="select-for-searchbar-field"
                style="font-size: 12px!important"
                v-model="filterSelectModel"
                @update:modelValue="changeFilterBy"
                menu-icon="ecc:ecc-M-Freccia"
                :items="dataStore.getFilters[currentTab]"
                :label="$t('breadcrumb.filterBy')"
                :single-line="true"
                density="compact"
                variant="filled"
              />
          </div>
          <div v-if="tagEnabled && isTagSelected" class="breadcrumb-divider"></div>
          <v-divider :thickness="2" vertical inset></v-divider>
            <!-- SEARCHBAR FOR ALARMS TYPE AND NAME  -->
          <Searchbar v-if="tagEnabled && isTagSelected"
            background="bg-white"
            :confirmEnabled="filterBySelected != null"
            :searchTitle="$t('breadcrumb.filterValue')"
            :iconEnabled="false"
            @emitInput="changeFilterModel"
            @confirm="validateChip"
            @setValue="validateChipFromSetValue"
            ref="filterSearchbar"
            :isAutocomplete="isAutocompleteMode"
            :autocompleteItems="dataStore.getAutocompleteItems"
          />  
          <animated-button
            v-if="tagEnabled && isTagSelected"
            @click="() => validateChip(filterModel)"
            icon="ecc:ecc-TB-Enter"
            :disabled="!canEnterFilterChip"
            >
          </animated-button>
          <animated-button
            icon="ecc:ecc-TB-Find"
            :isFilterActive="tagEnabled"
            :darkMode="isSearching && !isTagSelected"
            :value="!isTagSelected"
            v-bind:class="{ 'mr-3': !tagEnabled }"
            style="width: 22px; margin-left: 10px;"
            @click="toggleFilter('search')"
          />
          <div style='position:relative;display:flex'>
            <animated-button v-if="tagEnabled && dataStore.getFilters[currentTab]?.length > 0"
              icon="ecc:ecc-TB-Filter"
              :value="isTagSelected"
              :darkMode="isSearching && !isTagSelected"
              class="mr-3"
              v-bind:class="{ 'mr-3': tagEnabled, 'ml-3': false }"
              style="width: 22px"
              @click="toggleFilter('filter')"
            />
            <span class="icon-number" v-if="isTagSelected">{{
              tagNumber
            }}</span>
          </div>
        </v-layout>
    </v-layout>
    <v-layout
      v-if="showTagBar"
      class="justify-end align-center"
      style="width:100%; height: 40px; overflow:hidden;"
    >
      <div v-if="tagEnabled && isTagSelected">
        <v-chip
          class="ecc highlight-chip"
          style="margin:4px;height:25px;"
          v-for="(item, index) in currentFilters"
          v-bind:key="item.value"
        >
        <span v-if="index == 0 || currentFilters[index-1].data.key != currentFilters[index].data.key">
          {{ getTitleForKey(item.data.key) }}:&nbsp;
        </span>
          {{ item.data.value }}
          <v-btn
            data-qa="remove-chip-button"
            color="transparent"
            variant="text"
            class="close"
            @click="removeAlarmFilter(item)"
            min-width="25" width="25" size="x-small"
            >✕</v-btn>
        </v-chip>
      </div>
      <v-chip
          class="ecc" label variant="outlined" color="grey"
          style="margin:4px;height:25px;padding:0px;margin-right:30px"
          v-if="tagNumber != 0 && tagEnabled && isTagSelected"
        >
        <v-btn variant="plain" class="btnRemoveAll" @click="removeAllFilters()" min-width="25" width="25" size="x-small">
          ✕
        </v-btn>
      </v-chip>
    </v-layout>
  </div>
</template>

<script lang="ts">

import Searchbar from "./UIComponents/Searchbar.vue";
import AnimatedButton from "./UIComponents/AnimatedButton.vue";
import BreadcrumbFilterableMixin  from "../mixins/breadcrumbFilterable";
import { defineComponent } from "vue";
import { dataStore } from '../stores/data';
import { ALARM_TYPES_DB, BREADCRUMB_FILTER_BY_ENUM } from "../utils/type.util";

export default defineComponent({
  name: "Breadcrumb",
  props: {
    /**
     * Enables or disables the tag search input model.
     */
    showTagBar: {
      type: Boolean,
      default: true
    },
    tagEnabled: {
      type: Boolean,
      default: true
    },
    tagDefault: {
      type: Boolean,
      default: true
    },
    path: {
      type: Array<string>,
      default: ["", ""]
    },
    icon: {
      type: String,
      default: ""
    },
    searchTitle: {
      type: String,
      default: "Search..."
    },
    searchModel: {
      type: String,
      default: ""
    },
    sortModel: {
      type: Object,
      default: function() {
        return {};
      }
    },
    /**
     * Dictionary of which url query parameters should be edited
     * when user selects something. Uses currentTab as key.
     * Example:
     * { 'users': 'sortUserBy', 'groups': 'sortGroupBy', 'roles': 'sortRoleBy' }
     * yields
     * /#/permission?sortUserBy=something&sortGroupBy=somethingelse&sortRoleBy=test
     *
     * Important: Pages are expected to react to changes of their sortQueryKey with watch
     * or computed properties.
     */
    sortQueryKeys: {
      type: Object,
      default: function() {
        return {};
      }
    },
    sortingKeys: {
      type: Object,
      default: function() {
        return {};
      }
    },
    filterEnabledKeys: {
      type: Object,
      default: function() {
        return {};
      }
    },
    /**
     * On a single tab page this can be whatever the user wants.
     * On a multiple tab page it should be linked to the route name.
     * Functions as a key to every other dictionary (sorting and searching).
     */
    currentTab: {
      type: String,
      default: ""
    },
    searchKey: {
      type: String,
      default: "search"
    },
    filterPrefixes: {
      type: Object,
      default: function() {
        return {'alarms': 'alarms'};
      }
    },
    enableSortByHighlighting: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: Number,
      default: 0
    },
  },

  data: function() {
    return {
      sortAsc: true,
      sortValue: "",
      filterBySelected: null,
      filterByMode: BREADCRUMB_FILTER_BY_ENUM.FREE_TEXT,
      currentAutocompleteFunction:undefined,
      filterModel: '',
      searchValue: "",
      filterValue: '',
      filterSelectModel: this.$t('breadcrumb.filterBy'),
      currentFilters: [],
      dataStore: dataStore(),
    };
  },

  methods: {
    // mixin
    ...BreadcrumbFilterableMixin.methods,

    removeAllFilters(){
      let currentPrefix = this.filterPrefixes[this.currentTab];
      let filteredKeys = this.currentFilters.map(m => currentPrefix + m.data.key).filter((val, index, arr) => arr.indexOf(val) === index);
      let newQuery = JSON.parse(JSON.stringify(this.$route.query));
      filteredKeys.forEach(m => {
        delete newQuery[m];
      });
      this.$router.replace({
        query: newQuery
      });
    },

    removeAlarmFilter(item) {
      if (!item || !item.data) {
        console.error(item);
        return;
      }
      let newQuery = {};
      let currentPrefix = this.filterPrefixes[this.currentTab];
      Object.keys(this.$route.query).forEach(key => {
        if (key == currentPrefix + item.data.key) {
          //if it's an array we should copy all values without the one in item
          if (Array.isArray(this.$route.query[key])) {
            let newQueryValue = new Array();
            for (let k = 0; k < this.$route.query[key].length; k++) {
              if (this.$route.query[key][k] != item.data.value) {
                newQueryValue.push(this.$route.query[key][k]);
              }
            }
            newQuery[key] = newQueryValue;
          } else {
            //simply do nothing
          }
        } else {
          newQuery[key] = this.$route.query[key];
        }
      });
      this.$router.replace({
        query: newQuery
      });
    },

    async changeFilterBy(value:any) {
      if (value) {
        this.filterBySelected             = value.key;
        this.filterByMode                 = value.filterByMode;
        this.currentAutocompleteFunction  = value.autocompleteFunction;
        if(this.currentAutocompleteFunction!=undefined){
          await this.currentAutocompleteFunction(this.filterBySelected);
        }
      }
    },

    changeFilterModel(value: string) {
      this.filterModel = value;
    },

    validateChip(event) {
      if (this.filterBySelected != null && this.filterBySelected != undefined && event != "") {
        this.filterValue = "";
        this.filterModel = "";
        (this.$refs.filterSearchbar as InstanceType<typeof Searchbar>).clear();
        let currentPrefix = this.filterPrefixes[this.currentTab];
        // build query parameters array

        let queryParams = new Array();
        if (this.$route.query[currentPrefix + this.filterBySelected] != null) {
          if(Array.isArray(this.$route.query[currentPrefix + this.filterBySelected]))
          {
            if((this.$route.query[currentPrefix + this.filterBySelected] as string[]).filter( m=> m == event ).length > 0 )
            {
              //duplicated chip, ignore it
              return;
            }
          } else {
            if(this.$route.query[currentPrefix + this.filterBySelected] == event)
            {
              //duplicated chip, ignore it
              return;
            }
          }
          queryParams = [
            ...this.$route.query[currentPrefix + this.filterBySelected],
            event
          ];
        } else {
          queryParams = [event];
        }
        this.$router.replace({
          query: {
            ...this.$route.query,
            [this.searchKey]: undefined,
            [currentPrefix + this.filterBySelected]: queryParams
          }
        });
      } else {

      }
    },

    validateChipFromSetValue(event) {
      this.filterModel = event;
      const elements = this.dataStore?.getAutocompleteItems;
      const element = elements?.find(e => e.id === event);
      if (element) this.validateChip(element.id)
    },

    searchEnter(value) {
      this.searchValue = value;
      this.$router.replace({
        query: {
          ...this.$route.query,
          [this.searchKey]: this.searchValue
        }
      });
    },

    sort($event) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          [this.sortQueryKeys[this.currentTab]]: $event
        }
      });
    },

    async toggleFilter(tagOrSearch) {
      this.filterModel = "";
      this.$router.replace({
        query: {
          ...this.$route.query,
          [this.filterEnabledKeys[this.currentTab]]: tagOrSearch == 'filter' ? "true" : "false"
        }
      })
    },

    reverseSort() {
      this.sortAsc = !this.sortAsc;
      this.sortSelect(this.sortValue);
    },

    sortSelect($event) {
      this.sortValue=$event;
      
      (this.$refs.sortDropdown as any).isFocused = false;
      (this.$refs.sortDropdown as any).isMenuActive = false;
      this.sort($event + (this.sortAsc ? "Asc" : "Desc"));
    },

    parseSort() {
      const val = this.sortModel;
      if (!val || !this.currentTab) {
        console.error("invalid parse sort", val, this.currentTab);
      }
      if (val[this.currentTab] != undefined) {
        this.sortValue = val[this.currentTab]
          .replace("Asc", "")
          .replace("Desc", "");
        this.sortAsc = val[this.currentTab].indexOf("Asc") > 0 ? true : false;
      }else{
        this.sortValue = this.$t('breadcrumb.sortBy').toString();
        }
    },

    async parseFilterEnabled() {
      if(this.tagEnabled) {
        await this.toggleFilter(this.isTagSelected ? 'filter' : 'search')
      }
    },

    parseQuery(query) {
      if(!query) return;
      const filters = this.parseQueryFilters(query, this.filterPrefixes[this.currentTab])
      this.currentFilters = [];
      if(filters == undefined) return;
      filters.forEach(item => {
        this.currentFilters.push({
          value: item.value,
          data: item.data,
          alias: item.data.key == 'type' ? 'type: ' + ALARM_TYPES_DB.filter(at => at.id == item.data.value)[0].alias : item.value,
        });
      });
    },

    getTitleForKey(key: string) {
      return this.dataStore.getFilters[this.currentTab].find(filter => filter.value?.key === key)?.title || key;
    },
  },

  async mounted() {
    this.parseSort(this.sortModel);
    this.parseQuery(this.$route.query);
    await this.parseFilterEnabled();
    await this.dataStore.fetchFilters();
  },

  watch: {
    '$route.query': function(val) {
      this.parseQuery(val);
    },
    sortModel: function() {
      this.parseSort();
    },
    async currentTab() {
      this.parseSort();
      this.parseQuery(this.$route.query);
      this.$refs["select-for-searchbar-field"]?.reset();
      this.filterModel = "";
      this.filterBySelected = null;
      this.filterByMode = BREADCRUMB_FILTER_BY_ENUM.FREE_TEXT;
      this.filterSelectModel = this.$t('breadcrumb.filterBy');
      await this.dataStore.fetchFilters();
    },
  },
  computed: {
    isSearching() : boolean {
      return this.searchModel != '';
    },
    canEnterFilterChip() : boolean{
      return this.filterBySelected != null && this.filterModel !== "" 
    },
    tagNumber() : number {
      return this.currentFilters.length;
    },
    sortingValues() : any {
      return this.sortingKeys && this.sortingKeys[this.currentTab] ? Object.keys(this.sortingKeys[this.currentTab]).map(sk => ({
        text: this.sortingKeys[this.currentTab][sk],
        value: sk
      })) : [];
    },
    isTagSelected() : boolean {
      if(this.$route.query[this.filterEnabledKeys[this.currentTab]] === undefined) {
        return this.tagDefault;
      }
      const b = this.$route.query[this.filterEnabledKeys[this.currentTab]] ? (this.$route.query[this.filterEnabledKeys[this.currentTab]] === 'true') : false;
      return b
    },
    isAutocompleteMode():boolean{
      return this.filterByMode == BREADCRUMB_FILTER_BY_ENUM.AUTOCOMPLETE ? true : false;
    },
    needHighlightSortBy(): any{
      return this.enableSortByHighlighting && this.$route.query?.[this.sortQueryKeys[this.currentTab]] ? true : false;
    },
  },
  components: {
    Searchbar,
    AnimatedButton
  }
});
</script>

<style scoped>
/* looks like this is a necessary evil, otherwise its children won't obey the "fill-height" class */
/*.secondaryTopbar {
   height: 40px; 
}*/

.secondaryTopbar .searchbar {
  width: 336px;
}

.secondaryTopbar .sort-dropdown {
  outline: none;
  width: 17em;
}

.secondaryTopbar .primary--text {
  color: var(--color-highlight) !important;
}

.breadcrumb-element {
  height: 40px;
  min-width: 200px;
}
</style>

<style scoped>
.icon-number {
  position: absolute;
  right: 8px;
  bottom: 6px;
  width: 12px;
  height: 12px;
  color: var(--color-wt);
  background-color: var(--color-highlight);
  border-radius: 8px;
  font-size: 9px;
  line-height: 12px;
  text-align: center;
}

.btnRemoveAll {
  margin: 0px;
  width: 25px;
  height: 25px;
  color: var(--color-dk) !important;
}

.filterEnterChip.animatedButton:not([disabled]) >>> .v-icon {
  color: var(--color-dk);
}

.sort-dropdown >>> .v-date-range .layout {
  border: 0 !important;
}

.sort-dropdown >>> .v-autocomplete.v-select.v-input--is-focused input {
  min-width: 0px;
}

/*vuetify 3 style*/
:deep(.corvina-select.v-input.v-select){
  height: 40px;
  margin-bottom: 0px;
}
:deep(.corvina-select.v-input.v-select  .v-label){
  font-size: 12px;
  height: 100%;
  opacity: 1;
}

:deep(.corvina-select .v-list-item-title){
  font-size: 12px;
}

:deep(.corvina-select.v-input.v-select .v-field){
  border-radius: 0px;
  background: inherit;
}

:deep(.corvina-select.v-input.v-select .v-field .v-field__append-inner > .v-icon){
  opacity: 1;
}

:deep(.corvina-select.v-select .v-field--single-line .v-select__selection-text){
  padding-top: 4px;
  color: rgba(var(--v-theme-on-background), var(--v-high-emphasis-opacity));
}
:deep(.corvina-select.v-select.no-underline .v-field--variant-filled .v-field__outline::before){
  display: none;
}
:deep(.corvina-select.v-select.no-underline .v-field--variant-filled .v-field__overlay){
  background-color: inherit;
}
:deep(.corvina-select.v-select.no-underline .v-field--variant-filled .v-field__outline){
  display: none;
}

.sorticon {
  border: 1px solid var(--color-g4);
  border-radius: 3px;
}
.sort-dropdown-button{
  border-radius: 0px;
  width: auto;
  height: auto;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  margin: auto;
}
</style>
